import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../styles/Layout.css";

export default function Layout() {
  return (
    <>
      <div className="App">
        <Header />
        <main className="layout-main">
          <Outlet />
        </main>
        <Footer />
        <div id="load-icon-wrapper">
          <div className="load-icon rotate">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
          <h3>Please wait a moment...</h3>
        </div>
      </div>
    </>
  );
}
